import React from 'react';
import { cn } from '../utils/cn';
export const FormSection = React.forwardRef(function FormSection(
  { heading, description, className, children, ...props },
  ref,
) {
  return (
    <div ref={ref} className={cn(className)} role="group" {...props}>
      <h3 className="text-base font-semibold text-fg">{heading}</h3>
      {description && <p className="mt-1 text-sm text-fg-tertiary">{description}</p>}
      <div className="mt-4 space-y-4">{children}</div>
    </div>
  );
});
